import { getTaskList, completeTask } from '@this/services/task';
import orderBy from 'lodash/orderBy';

const state = {
  allTaskList: [],
  showAllTask: false,
};

const mutations = {
  setAllTaskList(state, list) {
    state.allTaskList = list;
  },
  setShowAllTask(state, bool) {
    state.showAllTask = bool;
  },
  setTaskStatus(state, task) {
    const { allTaskList } = state;
    const index = allTaskList.findIndex((item) => item.id === task.id);
    if (index > -1) {
      state.allTaskList[index].num -= 1;
    }
  },
};

const getters = {
  taskList(state) {
    const { allTaskList, showAllTask } = state;
    let taskList = orderBy(JSON.parse(JSON.stringify(allTaskList)), ['num'], ['desc']);
    if (!showAllTask) {
      taskList = taskList.splice(0, 1);
    }
    return taskList;
  },
};

const actions = {
  // 事件
  getTaskList({ commit }) {
    return getTaskList().then((res) => {
      commit('setAllTaskList', res.data.list);
    });
  },
  async clickTask({ dispatch }, task) {
    const { num, id } = task;
    if (num === 0 || id === 't_1') {
      dispatch('gotoTask', task);
    } else {
      dispatch('completeTask', task)
        .then(() => {
          dispatch('gotoTask', task);
          dispatch('changeTaskStatus', task);
          dispatch('plusUserChance');
        })
        .catch(() => {
          dispatch('gotoTask', task);
        });
    }
  },
  changeShowAllTask({ commit, state }, bool) {
    const showAllTask = bool ?? !state.showAllTask;
    commit('setShowAllTask', showAllTask);
  },
  // 步骤
  async gotoTask({ dispatch }, task) {
    const { id, url } = task;
    if (id === 't_1') {
      await dispatch('config/getSharePicture', null, { root: true });
      dispatch('goto/gotoShare', null, { root: true });
    } else if (url) {
      dispatch('goto/gotoLink', url, { root: true });
    }
  },
  completeTask(context, task) {
    return completeTask({
      tid: task.id,
    });
  },
  changeTaskStatus({ commit }, task) {
    commit('setTaskStatus', task);
  },
  plusUserChance({ commit }) {
    commit('user/calcUserChance', { type: 'plus' }, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
